export default "__VITE_ASSET__C0LxXrl5__"